export const highlightKeyword = (text: string, keyword: string) => {
    if (!keyword) return text;
    const regex = new RegExp(`(${keyword})`, "gi");
    console.log(text.replace(regex, '<span class="highlight-text">$1</span>'), "1234");
    return text.replace(regex, '<span class="highlight-text">$1</span>');
};
